import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationWsService implements OnDestroy {

  private ws: WebSocket | null = null;
  private reconnectDelay = 3000;
  private reconnectTimer: any = null;
  private destroyed = false;
  private currentToken: string | null = null;

  notifications$ = new BehaviorSubject<any[]>([]);

  constructor(private router: Router) {}

  connect(token: string): void {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      console.log('[NotifWS] connect() ignoré — connexion déjà ouverte (readyState=OPEN)');
      return;
    }
    console.log('[NotifWS] Initialisation de la connexion...');
    this.destroyed = false;
    this.currentToken = token;
    this._open(token);
  }

  disconnect(): void {
    console.log('[NotifWS] Déconnexion manuelle demandée');
    this.destroyed = true;
    this.currentToken = null;
    clearTimeout(this.reconnectTimer);
    this.ws?.close();
    this.ws = null;
    this.notifications$.next([]);
    console.log('[NotifWS] WebSocket fermé, notifications réinitialisées');
  }

  ngOnDestroy(): void {
    this.disconnect();
  }

  private _open(token: string): void {
    const url = `${environment.wsUrl}/ws/notification/in-progress/?token=${token}`;
    console.log('[NotifWS] Ouverture WebSocket →', url.replace(/token=.*/, 'token=***'));
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      console.log('[NotifWS] ✅ Connecté aux notifications in-progress');
      this.reconnectDelay = 3000;
    };

    this.ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        console.log('[NotifWS] Message reçu — type:', msg.type);
        if (msg.type === 'notifications_in_progress') {
          console.log('[NotifWS] notifications_in_progress — nb:', msg.data?.length ?? 0, 'items');
          this.notifications$.next(msg.data);
        } else {
          console.warn('[NotifWS] Type de message non géré:', msg.type);
        }
      } catch (err) {
        console.error('[NotifWS] Erreur parsing message', err, '| données brutes:', event.data);
      }
    };

    this.ws.onclose = (event) => {
      console.warn(`[NotifWS] ❌ Déconnecté — code=${event.code}, reason="${event.reason}", wasClean=${event.wasClean}`);
      if (event.code === 4401) {
        console.error('[NotifWS] Token invalide (4401) → redirection login');
        this.router.navigate(['/authentication/signin']);
        return;
      }
      if (!this.destroyed && this.currentToken) {
        console.log(`[NotifWS] Reconnexion dans ${this.reconnectDelay}ms (prochain délai: ${Math.min(this.reconnectDelay * 2, 30000)}ms)`);
        this.reconnectTimer = setTimeout(() => {
          this.reconnectDelay = Math.min(this.reconnectDelay * 2, 30000);
          this._open(this.currentToken);
        }, this.reconnectDelay);
      } else {
        console.log('[NotifWS] Pas de reconnexion (destroyed=true ou token absent)');
      }
    };

    this.ws.onerror = (err) => {
      console.error('[NotifWS] ⚠️ Erreur WebSocket', err);
    };
  }
}
